const o = 2;
export {
  o as CELL_FACE_PADDING
};
